"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDefined = exports.keyBy = void 0;
const keyBy = (arr, key) => {
    return arr.reduce((acc, cur) => {
        acc[cur[key]] = cur;
        return acc;
    }, {});
};
exports.keyBy = keyBy;
const mapDefined = (arr, fn) => {
    const output = [];
    for (const item of arr) {
        const val = fn(item);
        if (val !== undefined) {
            output.push(val);
        }
    }
    return output;
};
exports.mapDefined = mapDefined;
//# sourceMappingURL=arrays.js.map